import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Autocomplete,
  TextField,
} from '@mui/material';

const AssignDialog = ({
  open,
  selectedLead,
  selectedUsers = [],
  usersList,
  processingId,
  onClose,
  onUsersChange,
  onAssign,
}) => {
  const selectedUserObjs = (selectedUsers || [])
    .map((id) => usersList.find((u) => u.id === id))
    .filter(Boolean);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assign Lead to User</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          value={selectedUserObjs}
          onChange={(event, newValue) => {
            onUsersChange(newValue ? newValue.map((u) => u.id) : []);
          }}
          options={usersList}
          getOptionLabel={(option) => option.name ?? ''}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              <div>
                <div>{option.name}</div>
                {option.email && (
                  <div style={{ fontSize: '0.8em', color: '#666' }}>
                    {option.email}
                  </div>
                )}
              </div>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search & select users..."
              placeholder="Type name or email..."
              margin="normal"
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onAssign}
          variant="contained"
          disabled={!selectedUserObjs.length || processingId === selectedLead?.id}
          startIcon={
            processingId === selectedLead?.id ? <CircularProgress size={20} /> : null
          }
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignDialog;
